﻿﻿﻿<h2>Function configuration for {{defaults.controllertype.Description}}</h2>

<functionsconfig-list [list]="list" (onReload)="reload($event)" (onGlobalReload)="getFunctionsConfig()"></functionsconfig-list>